import { Component, Input } from '@angular/core';
import { TagItem } from 'app/components/common/tag/tag.component';

export class ClickableBoxItem {
    constructor(public title: string, public link: string) { }

    public image?: string;
    public tags?: TagItem[] = [];
    public additionalInfo?: string[] = [];
    public headerInfo?: HeaderInfo[] = [];
}

export class HeaderInfo {
    constructor(public label: string, public value: string, public icon?: string) { }
}

@Component({
    selector: 'psm-clickable-box',
    templateUrl: 'clickableBox.component.html',
    styleUrls: ['clickableBox.component.scss']
})
export class ClickableBoxComponent {
    @Input()
    public item: ClickableBoxItem;
}



// WEBPACK FOOTER //
// ./src/app/components/common/clickableBox/clickableBox.component.ts